/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatementUpdate } from './StatementUpdate';
import {
    StatementUpdateFromJSON,
    StatementUpdateFromJSONTyped,
    StatementUpdateToJSON,
    StatementUpdateToJSONTyped,
} from './StatementUpdate';

/**
 * The statement updates of a competition's problems, at most 50 per request.
 * @export
 * @interface StatementUpdates
 */
export interface StatementUpdates {
    /**
     * 
     * @type {Array<StatementUpdate>}
     * @memberof StatementUpdates
     */
    updates: Array<StatementUpdate>;
}

/**
 * Check if a given object implements the StatementUpdates interface.
 */
export function instanceOfStatementUpdates(value: object): value is StatementUpdates {
    if (!('updates' in value) || value['updates'] === undefined) return false;
    return true;
}

export function StatementUpdatesFromJSON(json: any): StatementUpdates {
    return StatementUpdatesFromJSONTyped(json, false);
}

export function StatementUpdatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementUpdates {
    if (json == null) {
        return json;
    }
    return {
        
        'updates': ((json['updates'] as Array<any>).map(StatementUpdateFromJSON)),
    };
}

export function StatementUpdatesToJSON(json: any): StatementUpdates {
    return StatementUpdatesToJSONTyped(json, false);
}

export function StatementUpdatesToJSONTyped(value?: StatementUpdates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updates': ((value['updates'] as Array<any>).map(StatementUpdateToJSON)),
    };
}

